import { Address, emptyAddress } from 'common/api/models/Address';
import { CountryCode } from 'common/api/crm/organization/enrollment/models';

export type OrgPeople = 10 | 50 | 200 | 500 | 1000 | 1500;

export enum PlanType {
    Lite = 'Lite',
    Plus = 'Plus',
}
export interface Organization {
    id?: string;
    name: string;
    address: Address;
    phoneNumber: string;
    pin: string | null;
    organizationTypeId: string;
    numberOfFamilies: number | null;
    fundraisingPurpose: string | null;
    website: string | null;
    answers?: { [key: string]: boolean };
    people?: OrgPeople;
    planType?: PlanType;
    isP2PInviteEnabled?: boolean;
    ein?: string;
    countryCode: CountryCode;
    smsOptedIn?: boolean;
}

export const emptyOrganization: Organization = {
    name: '',
    address: emptyAddress,
    phoneNumber: '',
    pin: null,
    organizationTypeId: '',
    numberOfFamilies: null,
    fundraisingPurpose: null,
    website: null,
    isP2PInviteEnabled: false,
    ein: '',
    countryCode: 'US',
    // smsOptedIn is deliberately absent: undefined means "never asked". Only the org
    // enrollment flows that render the opt-in checkbox send the field (ENG-120); flows that
    // seed from emptyOrganization without a checkbox must not emit an explicit false,
    // which the backend records as "asked and declined".
};
